import type { SafeLuminary } from '@lumen5/luminary';
import { VideoData } from '@lumen5/luminary';

import { isLayeredGraphicScene } from './layeredGraphic';

import { SKILL_NAMES } from 'js/src/agent/skills/skillNames';
import { sceneDisplayId } from 'js/src/agent/tools/scene-addressing';
import type { HtmlAsset } from 'js/src/luminary/html-asset-operations';

export interface FrameSize {
    width: number;
    height: number;
}

/**
 * Scenes whose whole graphic is authored HTML. An aspect ratio switch keeps that HTML, but it is
 * still laid out for the frame it was written for.
 */
export function authoredHtmlSceneIds(luminary: SafeLuminary): string[] {
    return luminary.scenes
        .filter(
            (scene) =>
                !isLayeredGraphicScene(scene) &&
                (scene.getAssetsByType(VideoData.HTML_ASSET_TYPE) as HtmlAsset[]).some(
                    (asset) => asset.html.trim() !== '',
                ),
        )
        .map((scene) => scene.id);
}

/** Tells the agent which scenes to lay out again after an aspect ratio switch. */
export function htmlScenesRelayoutNote(
    luminary: SafeLuminary,
    sceneIds: string[],
    from: FrameSize,
    to: FrameSize,
): string {
    const scenes = sceneIds.map((sceneId) => sceneDisplayId(luminary, sceneId)).join(', ');
    return (
        `The video's frame changed from ${from.width}×${from.height} to ${to.width}×${to.height}, ` +
        `and these scenes' HTML is laid out for the old one: scene_id ${scenes}. Lay each out ` +
        `again for the new frame; \`${SKILL_NAMES.chartScenes}\` says how for a chart scene.`
    );
}
